import { FormControl, FormHelperText, Grid, InputAdornment, OutlinedInput, Paper, Typography } from "@material-ui/core";
import { Field, Form, reduxForm } from "redux-form";
import ErrorIcon from '@material-ui/icons/Error';
import useStyles from '../styles/styles';
import PeButton from "../components/PeButton";
import PeSnackBar from "../components/PeSnackBar";
import { MdKeyboardBackspace } from 'react-icons/md';
import login from '../assets/img/login.svg';
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import State from '../states/State';
import loadingSlice from '../states/loading/slice';
import onLogin from '../thunks/onLogin';

type InputFieldProps = {
    readonly input?: any,
    readonly type: string,
    readonly placeholder?: string,
    readonly id: string,
    readonly label: string,
    readonly adornment?: string,
    readonly required?: boolean,
    readonly meta?: { 
      touched: any, 
      error: any 
    }
}
const InputField: React.FC<InputFieldProps> = props => {
    const classes = useStyles();
    return <FormControl error={Boolean(props.meta?.error)} variant="outlined" className={classes.Login_control} style={{padding: '5px 25px'}}>
        <h4 className={classes.label}>{props.required && <span className={classes.required}>*</span>}&nbsp;{props.label}</h4>
        <OutlinedInput
        id={props.id}
        placeholder={props.placeholder}
        type={props.type}
        startAdornment={props.adornment && <InputAdornment position="start">{props.adornment}</InputAdornment>}
        {...props.input}
        />
        {props.meta?.error && <FormHelperText className={classes.helpText} component="p"><ErrorIcon fontSize="small"/>&nbsp;{props.meta?.error}</FormHelperText>}
        </FormControl>
    }
    type LoginFormProps = {
    readonly handleSubmit: any,
}
const LoginFormRaw: React.FC<LoginFormProps> = props => {
    const classes = useStyles();

    return <Form onSubmit={props.handleSubmit}>
        <Field name="user_name" label="User name:" component={InputField} required></Field>
        <Field name="user_pass" label="Password:" component={InputField} required type="password"></Field>
        <div className={classes.Login_button}><PeButton type="submit" label="Login" disable={false}/></div>
    </Form>
    }
    const LoginForm = reduxForm({
    form: 'login-form',
    // validate: validate,
    // initialValues: initialProductChoice,
    enableReinitialize: true,
})(LoginFormRaw)

type LoginProps = {}

const Login: React.FC<LoginProps> = props => {
    const classes = useStyles();
    const history = useHistory();
    const prevPath = new URLSearchParams(history.location.search).get('callback');
    const dispatch = useDispatch();

    const state = useSelector((state: State) => ({
        shell: state.shell,
    }));

    const isLayout = state.shell.layout;
    const isAuth = state.shell.isAuth;

    const handleSubmit = async (values: any) => {
        // console.log(prevPath);
        if (values.user_name && values.user_pass) {
        await dispatch(onLogin(values.user_name, values.user_pass));
        }
    }

    const handleBackClick = () => {
        dispatch(loadingSlice.actions.updateLoading({isOpen: true, message: ''}));
        history.push(prevPath ? prevPath : "/");
    }

    React.useEffect(() => {
        if (isAuth) history.push(prevPath ? prevPath : "/master");
        // eslint-disable-next-line
    }, [isAuth]);

    return <div className={classes.app}>
        <PeSnackBar />
        { !prevPath && <div className={classes.nav} onClick={handleBackClick}>
        <Typography variant="h5" component="h2" className={classes.headerTxt}><MdKeyboardBackspace />&nbsp;Back to form</Typography>
        </div> }
        <Paper className={classes.Login_paper}>
        <Grid container style={{height: '100%'}}>
            {isLayout  === 0 && 
            <Grid item sm={6} className={classes.left}>
            <img src={login} alt="login_art"/>
            </Grid>
            }
            <Grid item sm={6} xs={12}>
            <Typography variant="h4" component="h2" className={classes.headerTxt}>Login</Typography>
            <LoginForm onSubmit={handleSubmit}/>
            </Grid>
        </Grid>
        </Paper>
  </div>
}
export default Login;

